// Static Tailwind classes so the JIT compiler keeps every span variant.
export const SPAN_CLASS = {
  2: "xl:col-span-2",
  3: "xl:col-span-3",
  4: "xl:col-span-4",
  5: "xl:col-span-5",
  6: "xl:col-span-6",
  7: "xl:col-span-7",
  8: "xl:col-span-8",
  9: "xl:col-span-9",
  10: "xl:col-span-10",
  11: "xl:col-span-11",
  12: "xl:col-span-12",
};

export const EDIT_SPAN_CLASS = {
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
  8: "col-span-8",
  9: "col-span-9",
  10: "col-span-10",
  11: "col-span-11",
  12: "col-span-12",
};

export const clampSpan = (n) => Math.max(2, Math.min(12, Math.round(Number(n) || 6)));

// Card heights in row units; row 1 is the card's natural height.
export const HEIGHT_CLASS = {
  1: "",
  2: "xl:h-[380px]",
  3: "xl:h-[560px]",
  4: "xl:h-[740px]",
};

export const clampRows = (n) => Math.max(1, Math.min(4, Math.round(Number(n) || 1)));
